// This file is auto-generated by the `update-kc-gen` command. Do not edit it manually.
// Hash: b0aa286dba4ed04c111c1265bdb6a76ba45c22a3d9b9e8dcf36302267d40c51a

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

import { Suspense, type ReactNode } from "react";
import KcApp from './KcApp';

export type ThemeName = "keycloakify-starter";

export const themeNames: ThemeName[] = ["keycloakify-starter"];

export type KcEnvName = never;

export const kcEnvNames: KcEnvName[] = [];

export const kcEnvDefaults: Record<KcEnvName, string> = {};

/**
 * NOTE: Do not import this type except maybe in your entrypoint.
 * If you need to import the KcContext import it either from src/login/KcContext.ts or src/account/KcContext.ts.
 * Depending on the theme type you are working on.
 */
export type KcContext = import("./login/KcContext").KcContext;

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}


export function KcPage(props: { kcContext: KcContext; fallback?: ReactNode }) {
  const { kcContext, fallback } = props;
  console.log("kcContext pageId:", window.kcContext?.pageId);
  console.log("kcContext loginAction:", window.kcContext?.url?.loginAction);
  return (
    <Suspense fallback={fallback}>
      <KcApp kcContext={kcContext} />
    </Suspense>
  );
}

// NOTE: This is exported here only because in Webpack environnement it works differently
export const BASE_URL = process.env.BASE_URL;

// NOTE: This is only exported here because you're supposed to import type from different packages
// Depending of if you are using Vite, Webpack, ect...
export type { Meta, StoryObj } from "@storybook/react-vite";